export const ANALYTICS_EVENTS = {
  POPUP_VIEWED: 'popup_viewed',
  BUTTON_CLICKED: 'button_clicked',
  PAGE_VIEWED: 'page_viewed',
  ERROR_VIEWED: 'error_viewed',
  RETENTION_POPUP_SHOWN: 'retention_popup_shown',
  RETENTION_POPUP_CTA_CLICK: 'retention_popup_cta_click',
  RETENTION_POPUP_DISMISS: 'retention_popup_dismiss',
  DEFERRED_LOGIN_ISSUE: 'deferred_login_issue',
  DEFERRED_LOGIN_STORE_REDIRECT: 'deferred_login_store_redirect',
  DEFERRED_LOGIN_EXCHANGE_SUCCESS: 'deferred_login_exchange_success',
  DEFERRED_LOGIN_EXCHANGE_FAIL: 'deferred_login_exchange_fail',
} as const

export type AnalyticsEventName = (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS]
